import React, { useState, useRef, useCallback, useEffect } from 'react';
import { PlayPauseButton } from '.';

const GalleryVideo = ({ media }) => {
  const [paused, setPaused] = useState(true);

  const videoRef = useRef(null);

  useEffect(() => {
    const playListener = () => {
      setPaused(false);
    };
    const pauseListener = () => {
      setPaused(true);
    };

    if (videoRef) {
      videoRef.current.addEventListener('play', playListener);
      videoRef.current.addEventListener('pause', pauseListener);

      setTimeout(() => {
        videoRef.current.play();
        setPaused(false);
      });
    }

    return () => {
      videoRef.current.removeEventListener('play', playListener);
      videoRef.current.removeEventListener('pause', pauseListener);
    };
  }, [videoRef]);

  const handlePlayClick = useCallback(() => {
    if (videoRef) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setPaused(false);
      } else {
        videoRef.current.pause();
        setPaused(true);
      }
    }
  }, [videoRef, paused]);

  return (
    <div>
      <video className='h-full' controls src={media.src} ref={videoRef}></video>
      <PlayPauseButton
        paused={paused}
        onClick={handlePlayClick}
        className={'absolute top-0 bottom-0 right-0 left-0 m-auto'}
        hidden={!paused}
      />
    </div>
  );
};

export default GalleryVideo;
